import { motion } from 'framer-motion';

const stats = [
  { num: 500, suf: '+', label: 'Projects completed' },
  { num: 15, suf: '+', label: 'Years experience' },
  { num: 98, suf: '%', label: 'Client satisfaction' },
  { num: 120, suf: '+', label: 'Trade partners' },
];

const features = [
  {
    title: 'Precision workmanship',
    desc: 'Tight tolerances, clean welds, and finishes that reflect the calibre of your build.',
    icon: (
      <>
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
      </>
    ),
  },
  {
    title: 'Custom fabrication',
    desc: 'One-off details and repeat production — both engineered to your drawings and site reality.',
    icon: (
      <>
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </>
    ),
  },
  {
    title: 'Reliable turnaround',
    desc: 'Realistic programmes, proactive scheduling, and materials sourced to keep momentum.',
    icon: (
      <>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </>
    ),
  },
  {
    title: 'Quality materials',
    desc: 'Certified steel sections and consumables, fully traceable for structural peace of mind.',
    icon: (
      <>
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      </>
    ),
  },
  {
    title: 'Professional communication',
    desc: 'Single point of contact, clear documentation, and no surprises on costs or delivery.',
    icon: (
      <>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </>
    ),
  },
];

const fadeIn = (delay = 0) => ({
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.5, delay, ease: [0.25, 0.1, 0.25, 1] },
});

export default function WhyUs() {
  return (
    <section className="whyus" id="whyus">
      <div className="container">
        <div className="whyus-inner">
          <div className="whyus-left">
            <motion.div className="eyebrow" {...fadeIn(0)}>
              Why choose us
            </motion.div>
            <motion.h2 className="section-title" {...fadeIn(0.08)}>
              Steelwork you can
              <br />
              stake your reputation on
            </motion.h2>
            <motion.p className="section-sub" {...fadeIn(0.16)}>
              We partner with contractors, architects, and homeowners who need steel that
              looks sharp, performs structurally, and arrives when promised — without the
              drama.
            </motion.p>

            <motion.div
              className="whyus-stats"
              {...fadeIn(0.22)}
            >
              {stats.map((s) => (
                <div key={s.label} className="stat-box">
                  <div className="stat-num">
                    <span>{s.num}</span>
                    <span className="stat-suf">{s.suf}</span>
                  </div>
                  <div className="stat-lbl">{s.label}</div>
                </div>
              ))}
            </motion.div>
          </div>

          <motion.div
            className="whyus-features"
            {...fadeIn(0.26)}
          >
            {features.map((f) => (
              <div key={f.title} className="feature-row">
                <div className="feat-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {f.icon}
                  </svg>
                </div>
                <div>
                  <div className="feat-title">{f.title}</div>
                  <div className="feat-desc">{f.desc}</div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
